import { SavedItemFilter, GetUrlsFilter } from '../types'

const serializeFilters = (filters: SavedItemFilter = {}) => {
  const entries = Object.entries(filters).filter(([, value]) => value !== undefined && value !== null && value !== '')
  // Sort keys for stable output
  const sorted = entries.sort(([a], [b]) => a.localeCompare(b))
  return JSON.stringify(Object.fromEntries(sorted))
}

const serializeUrlFilters = (filters: GetUrlsFilter = {}) => {
  const entries = Object.entries(filters).filter(([, value]) => value !== undefined && value !== null && value !== '')
  const sorted = entries.sort(([a], [b]) => a.localeCompare(b))
  return JSON.stringify(Object.fromEntries(sorted))
}

export const savedItemsKeys = {
  all: ['saved-items'] as const,
  list: (filters: SavedItemFilter = {}) => ['saved-items', 'list', serializeFilters(filters)] as const,
  detail: (id: string) => ['saved-items', 'detail', id] as const,
}

export const collectionKeys = {
  all: ['collections'] as const,
  list: ['collections', 'list'] as const,
  detail: (id: string) => ['collections', 'detail', id] as const,
}

export const urlKeys = {
  all: ['urls'] as const,
  list: (filters: GetUrlsFilter = {}) => ['urls', 'list', serializeUrlFilters(filters)] as const,
}
